import React from 'react';
import { Box, makeStyles, Typography } from '@material-ui/core';
var useStyles = makeStyles(function (theme) { return ({
    imageBox: {
        position: 'relative',
    },
    image: function (props) {
        var fullWidth = {
            width: '100%',
            height: '100%',
            opacity: 1.0,
        };
        if (props.unavailable) {
            fullWidth.opacity = 0.1;
        }
        return fullWidth;
    },
    unavailable: {
        display: 'flex',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        top: '50%',
        left: '50%',
        textAlign: 'center',
        transform: 'translateX(-50%) translateY(-50%)',
        fontSize: '7vw',
        fontWeight: 600,
        color: theme.palette.grey['800'],
    },
}); });
export var ProductImage = function (props) {
    var unavailable = props.expired || props.used;
    var classes = useStyles({ unavailable: unavailable });
    return (React.createElement(Box, { className: classes.imageBox },
        React.createElement("img", { src: props.imageUrl, className: classes.image, alt: props.couponName }),
        (function () {
            if (props.expired) {
                return React.createElement(Typography, { className: classes.unavailable }, "\u6709\u52B9\u671F\u9650\u5207\u308C");
            }
            else if (props.used) {
                return React.createElement(Typography, { className: classes.unavailable }, "\u4F7F\u7528\u6E08\u307F");
            }
            else {
                return React.createElement(React.Fragment, null);
            }
        })()));
};
//# sourceMappingURL=ProductImage.js.map